import { UiDrawer, UiTextBox, UiButton, UiDatePicker, UiInputNumber, UiUpload } from "../../../../components";
import { PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import "./style.scss";

const OfferDrawer = ({ open, formData, onClose, onInputChange, onSubmit }) => {
    const handleImageUpload = ({ fileList }) => {
        onInputChange("imageFile", fileList?.slice(-1));
    };

    const handleCancel = () => {
        onClose();
    };
    const offerPercentage = formData?.offerPercentage ? Number(formData?.offerPercentage) : null;
    const isPercentageInvalid = Boolean(formData?.offerPercentage && (offerPercentage > 5 || offerPercentage <= 0 || isNaN(offerPercentage)));
    const isFormValid = formData?.offerName && formData?.startDate && formData?.endDate && formData?.day && formData?.offerPercentage && !isPercentageInvalid && formData?.imageFile?.length > 0;
    const uploadButton = (
        <div style={{ textAlign: "center", padding: "40px" }}>
            <PlusOutlined style={{ fontSize: "24px", color: "#999" }} />
            <div style={{ marginTop: 8, color: "#999" }}>Upload</div>
        </div>
    );
    return (
        <UiDrawer
            title="Offers"
            open={open}
            onClose={handleCancel}
            size="default"
            width={500}
        >
            <div className="coupon-drawer-content">
                <div className="content-wrapper">
                    <div className="form-group">
                        <div className="textbox-wrapper">
                            <UiTextBox
                                label="Offer Name"
                                required={true}
                                placeholder="Eg: New Year"
                                value={formData?.offerName}
                                onChange={(event) => onInputChange("offerName", event?.target?.value)}
                                style={{ width: "100%" }}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="form-label">
                            Start Date <span className="required">*</span>
                        </label>
                        <UiDatePicker
                            placeholder="Select date"
                            value={formData?.startDate ? dayjs(formData?.startDate) : null}
                            onChange={(date) => onInputChange("startDate", date)}
                            disabledDate={(currentDate) => currentDate && currentDate < dayjs().startOf("day")}
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div className="form-group">
                        <label className="form-label">
                            End Date <span className="required">*</span>
                        </label>
                        <UiDatePicker
                            placeholder="Select date"
                            value={formData?.endDate ? dayjs(formData?.endDate) : null}
                            onChange={(date) => onInputChange("endDate", date)}
                            disabledDate={(currentDate) =>
                                currentDate &&
                                (formData?.startDate
                                    ? currentDate < dayjs(formData.startDate).startOf("day")
                                    : currentDate < dayjs().startOf("day"))
                            }
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div className="form-group">
                        <div className="textbox-wrapper">
                            <UiInputNumber
                                label="Day"
                                required={true}
                                placeholder="0"
                                value={formData?.day}
                                disabled
                                style={{ width: "100%" }}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="textbox-wrapper">
                            <UiTextBox
                                label="Offer %"
                                required={true}
                                placeholder="Eg: 5%"
                                value={formData?.offerPercentage}
                                status={isPercentageInvalid ? "error" : ""}
                                onChange={(event) => {
                                    const digits = event?.target?.value?.replace(/[^0-9]/g, "")?.slice(0, 2);
                                    onInputChange("offerPercentage", digits);
                                }}
                                style={{ width: "100%" }}
                            />
                            {isPercentageInvalid ? (
                                <small className="offer-validation-message">
                                    {Number(formData?.offerPercentage) > 5 ? "Percentage cannot exceed 5%" : "Percentage must be greater than 0%"}
                                </small>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="form-label">
                            Upload Image <span className="required">*</span>
                        </label>
                        <UiUpload
                            listType="picture-card"
                            multiple={false}
                            maxCount={1}
                            accept="image/png, image/jpeg, image/jpg"
                            beforeUpload={() => false}
                            onChange={handleImageUpload}
                            fileList={formData?.imageFile || []}
                            className="upload-image"
                        >
                            {(formData?.imageFile?.length ?? 0) >= 1 ? null : uploadButton}
                        </UiUpload>
                    </div>
                </div>
                <div className="drawer-footer">
                    <UiButton
                        className="cancel-btn"
                        onClick={handleCancel}
                    >
                        Cancel
                    </UiButton>
                    <UiButton
                        className="send-btn"
                        onClick={onSubmit}
                        disabled={!isFormValid}
                    >
                        Send
                    </UiButton>
                </div>
            </div>
        </UiDrawer>
    );
};

export default OfferDrawer;
